import i18n from "../localization/i18n";
import Command from "../commands/Command";
import { useCurrentCommandState } from "../store/currentCommandStateStore";

export default class CommandStack {
    stack: Command[] = [];

    addToStack(cmd: Command) {
        this.getCurrentCmd()?.deactivate();
        this.stack.push(cmd);
        this.updateCurrentCommand(cmd);
        console.info(`${this.getCommandName(cmd)} was added to stack. ${this.getStackStatusText()}`);
    }

    removeFromStack(cmd: Command) {
        this.stack = this.stack.filter(c => c !== cmd);
        this.getCurrentCmd()?.activate();
        this.updateCurrentCommand(this.getCurrentCmd());
        console.info(`${this.getCommandName(cmd)} was removed from stack. ${this.getStackStatusText()}`);
    }

    updateCurrentCommand(cmd: Command | null) {
        if (cmd) {
            useCurrentCommandState.getState().setCurrentCommand(    cmd.getId(), 
                                                                    cmd.getNameResourceKey(), 
                                                                    cmd.getInitialPromptResourceKey(),
                                                                    cmd.getShowCommandInfo() );
        } else {
            useCurrentCommandState.getState().clearCurrentCommand();
        }   
    }

    getCommandName(cmd: Command): string {
        return `'${i18n.t(cmd.getNameResourceKey())}' command`;
    }

    getStackStatusText(): string {
        if (this.stack.length === 0) {
            return "Command stack is empty.";
        }   
        return `Command stack has ${this.stack.length} command(s): ` + this.stack.map(cmd => i18n.t(cmd.getNameResourceKey())).join(", ");
    }

    getCurrentCmd() : Command | null {
        return this.stack.length > 0 
                ? this.stack[this.stack.length-1]
                : null;
    }
}